import React from 'react'
import { useAppDispatch } from '../../../../hooks/redux'

import BaseModal from '../BaseModal2'
import ModalInput from '@SonarCX/components/atoms/ModalInput'
import Button from '@SonarCX/components/atoms/Button2'

import { renameArticle } from '../../../../slices/article'
import useStyles from './styles'

const EditFolderModal = ({ article, onClose }) => {
  const dispatch = useAppDispatch()

  const [name, setName] = React.useState(article.title)

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setName('')
    onClose()
  }, [onClose])

  React.useEffect(() => {
    setName(article.title)
  }, [article.title])

  const handleRename = React.useCallback(() => {
    const trimmed = name.trim()
    dispatch(renameArticle({ article, name: trimmed }))

    handleClose()
  }, [name, dispatch, article, handleClose])

  return (
    <BaseModal open disablePortal onClose={handleClose} title='Rename Folder'>
      <div className={classes.title}>Folder Name</div>

      <ModalInput
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder='Enter folder name'
        className={classes.input}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
        }}
      />

      <Button
        onClick={handleRename}
        disabled={name.trim().length === 0}
        className={classes.button}
      >
        Save Changes
      </Button>
    </BaseModal>
  )
}

export default EditFolderModal
